import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-销售数据汇总",
  "use": "icon-销售数据汇总-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-销售数据汇总\"><defs><style type=\"text/css\"></style></defs><path d=\"M182.044444 529.066667a312.888889 312.888889 0 0 0 620.714667 56.888889h-364.657778V221.184A313.059556 313.059556 0 0 0 182.044444 529.009778z m312.888889 369.777777a369.777778 369.777778 0 1 1 0-739.669333V529.066667h369.891556a369.834667 369.834667 0 0 1-369.777778 369.777777z\" p-id=\"16084\" fill=\"#ffffff\" /><path d=\"M606.549333 179.313778v238.136889h238.136889a297.528889 297.528889 0 0 0-238.136889-238.136889z m297.130667 292.295111H552.391111V120.32a351.288889 351.288889 0 0 1 351.288889 351.288889z\" p-id=\"16085\" fill=\"#ffffff\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/销售数据汇总.svg
// module id = 3wjd
// module chunks = 28